import { TrackingCategory, TrackingContext } from '@ps/web-shared-analytics';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { getDisplayName } from '@swf/core/utils';

import type { CashierFlowType } from '../../types/Cashier';
import WizardGroup from '../WizardGroup/WizardGroup';

import PaymentVerificationLobby from './components/PaymentVerificationLobby/PaymentVerificationLobby';
import PaymentVerificationMenu from './components/PaymentVerificationMenu/PaymentVerificationMenu';
import PaymentVerificationPage from './components/PaymentVerificationPage/PaymentVerificationPage';
import PaymentVerificationSummary from './components/PaymentVerificationSummary/PaymentVerificationSummary';
import usePaymentVerificationFlow from './hooks/usePaymentVerificationFlow';
import usePaymentVerificationGuardsData from './hooks/usePaymentVerificationGuardsData';
import usePaymentVerificationServicesData from './hooks/usePaymentVerificationServicesData';

interface Props {
  cashierFlow: CashierFlowType;
}

const PaymentVerification: React.FC<Props> = ({ cashierFlow }) => {
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const guards = usePaymentVerificationGuardsData();
  const services = usePaymentVerificationServicesData();

  const flow = usePaymentVerificationFlow(cashierFlow);

  return (
    <TrackingContext.Provider value={{ category: TrackingCategory.Deposit, isMobileEmbedded }}>
      <WizardGroup
        name={getDisplayName(PaymentVerification)}
        flow={flow}
        guards={guards}
        services={services}
      >
        <PaymentVerificationLobby />
        <PaymentVerificationMenu />
        <PaymentVerificationPage />
        <PaymentVerificationSummary />
      </WizardGroup>
    </TrackingContext.Provider>
  );
};

PaymentVerification.displayName = 'PaymentVerification';

export default PaymentVerification;
